import PropTypes from 'prop-types';
import {memo, useCallback} from 'react';

import useUserActions from '@/src/app/store/user/useUserActions';
import useIsMobile from '@/src/hooks/useIsMobile';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import AttachmentsLists from '@/src/ui/attachmentsLists/components/AttachmentsLists';

import {Collapse, Text} from '../../../ui';
import css from '../../styles/CourseTopicsDetails.module.css';
import TopicDetails from './TopicDetails';

const CourseTopicsDetails = ({topics, contentCreator}) => {
  const {user: userData} = useUserActions();

  const isDisableLink = !userData?.permissions?.accessWatchCourse;

  const {isMaxWidth600} = useIsMobile();
  const getTopicsVideos = useCallback(
    (videos) => {
      return videos.map((video) => (
        <TopicDetails
          id={video.id}
          contentCreator={contentCreator}
          key={video.id}
          videoPreview={video.previewImage}
          videDuration={video.duration}
          videoTitle={video.title}
        />
      ));
    },
    [topics, contentCreator]
  );

  const topicsList = topics.map((topic) => (
    <Collapse
      key={topic.id}
      headTitle={
        <div className={css.topicInfo}>
          <div className={css.title}>
            <Text
              isOneLine
              fontSize={
                isMaxWidth600 ? Text.FONT_SIZE.SIZE_12 : Text.FONT_SIZE.SIZE_16
              }
              fontWeight={Text.FONT_WEIGHT.BOLD}
            >
              {topic.title}
            </Text>
          </div>
          {Boolean(topic.videosCount) && (
            <div className={css.durationWrapper}>
              <Text
                fontSize={
                  isMaxWidth600
                    ? Text.FONT_SIZE.SIZE_12
                    : Text.FONT_SIZE.SIZE_14
                }
                color={Text.COLOR.PRIMARY}
                fontWeight={Text.FONT_WEIGHT.MEDIUM}
              >
                <div className={css.online}>
                  {topic.videosCount}{' '}
                  <TextLocal
                    id={
                      topic.videosCount <= 1
                        ? 'courseDetails.video'
                        : 'courseDetails.videos'
                    }
                  />{' '}
                  | {topic.videosDuration}
                </div>
              </Text>
            </div>
          )}
        </div>
      }
    >
      {getTopicsVideos(topic.videos)}
      <div className={css.attachmentsWrapper}>
        <AttachmentsLists
          files={topic.files}
          links={isDisableLink ? [] : topic.links}
          isSquare
          isWhiteBackground
          isDisableLinks={isDisableLink}
        />
      </div>
    </Collapse>
  ));

  return <div className={css.topicsWrapper}>{topicsList}</div>;
};

CourseTopicsDetails.propTypes = {
  topics: PropTypes.array.isRequired,
  contentCreator: PropTypes.string.isRequired,
};

CourseTopicsDetails.defaultProps = {
  topics: [],
  contentCreator: '',
};
export default memo(CourseTopicsDetails);
